import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { OptionalChip, RequiredChip, RHFExpertiseAutocomplete, RHFLanguagesTaughtInput } from '@onesource/components';
import { FC } from 'react';

import { ProDirectoryOfferingsCards } from './offerings-cards';
import { ProDirectoryTeachingFormatCards } from './teaching-format-cards';

type Props = {
  isPending: boolean;
};

export const ProDirectoryStepTeaching: FC<Props> = ({ isPending }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 0.75 }}>
          Languages Taught <RequiredChip />
        </Typography>
        <RHFLanguagesTaughtInput
          name="languagesTaught"
          disabled={isPending}
          helperText="Select your primary teaching languages"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 0.75 }}>
          Offerings & Services (Session Types) <OptionalChip />
        </Typography>
        <ProDirectoryOfferingsCards isPending={isPending} />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 0.75 }}>
          Teaching Format (Delivery Method) <RequiredChip />
        </Typography>
        <ProDirectoryTeachingFormatCards isPending={isPending} />
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5, ml: 1.75 }}>
          What kind of sessions do you teach?
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 0.75 }}>
          Support Areas <RequiredChip />
        </Typography>
        <RHFExpertiseAutocomplete
          name="expertise"
          disabled={isPending}
          maxSelections={10}
          helperText="Select the conditions you support (up to 10 selections)"
        />
      </Grid>
    </Grid>
  );
};
